export default {
    color:"צבע"
}